import { apiClient } from './apiClient';

export interface AssistantPatient {
  patientID: number;
  firstName: string;
  lastName: string;
  email: string;
  cellPhone: string;
  emailOptIn: boolean;
  smsOptIn: boolean;
  dateAdded: string | null;
  totalSpend: number;
  lastVisit: string | null;
  apptCount: number;
}

export interface AssistantFilter {
  name_contains?: string;
  created_after?: string;
  created_before?: string;
  last_visit_after?: string;
  last_visit_before?: string;
  include_no_visits?: boolean;
  no_visits?: boolean;
  total_spend_gte?: number;
  total_spend_lte?: number;
  appointment_count_gte?: number;
  has_email?: boolean;
  has_cell_phone?: boolean;
  email_opt_in?: boolean;
  sms_opt_in?: boolean;
  has_active_membership?: boolean;
  membership_template_names?: string[];
  tag_names?: string[];
  sort?: string;
  limit?: number;
}

export interface AssistantResults {
  filter: AssistantFilter;
  total: number;
  patients: AssistantPatient[];
}

export interface ProposalRecipient {
  patientID: number;
  firstName: string;
  lastName: string;
  email: string;
  cellPhone: string;
}

export interface SendProposal {
  channel: 'sms' | 'email' | 'push';
  subject: string;
  title: string;
  message: string;
  recipients: ProposalRecipient[];
  ineligible: Array<{ patientID: number; reason: string }>;
}

export interface ChatHistoryMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface ChatResponse {
  answer: string;
  results: AssistantResults | null;
  proposal: SendProposal | null;
}

export interface SendResult {
  sent: number;
  skipped: Array<{ patientID: number; reason: string }>;
}

export async function chatWithAssistant(payload: {
  question: string;
  allowActions: boolean;
  history: ChatHistoryMessage[];
}): Promise<ChatResponse> {
  const r = await apiClient.post('/ai-assistant/chat', payload);
  return r.data.data;
}

export async function confirmSend(payload: {
  channel: 'sms' | 'email' | 'push';
  subject?: string;
  title?: string;
  message: string;
  patient_ids: number[];
}): Promise<SendResult> {
  const r = await apiClient.post('/ai-assistant/send', payload);
  return r.data.data;
}
